import { Injectable } from '@angular/core';
import type { SafeResourceUrl } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class Jotform {
  constructor(private sanitizer: DomSanitizer) {}

  getJotformUrl(formName: string, urlParams?: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      new URL(
        `https://form.jotform.com/freelancer_com/${formName}?${urlParams}`,
      ).toString(),
    );
  }
}
